import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VueMaterial from 'vue-material';
import vuetify from '@/plugins/vuetify';
import Vuetify from 'vuetify/lib';
import VueI18n from 'vue-i18n';
import { he, en,pt,ru,es,ar, pl, uk, ro, nl, cs, ml, sk, ka, si } from './texts';
import { notificationHealthTexts } from './i18n/notificationHealth';
import { executiveReportTexts } from './i18n/executiveReport';
import { localeData, updateLocaleData } from './modules/common/services/localeService'
import { timePassed, numberToHour, ddmmyy, ddmm, dd, spacedTxt, formatSeconds, capitalize, statusColor, hhmm } from '@/filters'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import * as VueGoogleMaps from 'vue2-google-maps';
import gaEvent from './modules/common/directives/gaEvent';

Vue.config.productionTip = false;

Vue.use(VueMaterial);
Vue.use(VueI18n);
// Suppress Google Maps deprecation warnings (they're just warnings, functionality still works)
// These warnings come from vue2-google-maps using deprecated APIs
const originalWarn = console.warn;
console.warn = function(...args) {
  const message = args.join(' ');
  // Filter out Google Maps deprecation warnings
  if (
    message.includes('google.maps.places.Autocomplete') ||
    message.includes('google.maps.Marker') ||
    message.includes('loading=async') ||
    message.includes('PlaceAutocompleteElement') ||
    message.includes('AdvancedMarkerElement') ||
    message.includes('deprecated') && message.includes('google.maps')
  ) {
    // Suppress these specific warnings
    return;
  }
  // Call original warn for other messages
  originalWarn.apply(console, args);
};

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
    libraries: 'places', // Includes libraries needed for autocomplete
  },
  installComponents: true, // Registers components globally
})
updateLocaleData()
const { language } = localeData
const messages = {
	en: { ...en, ...notificationHealthTexts.en, ...executiveReportTexts.en },
	he: { ...he, ...notificationHealthTexts.he, ...executiveReportTexts.he },
	pt: { ...pt, ...notificationHealthTexts.pt, ...executiveReportTexts.pt },
	ru: { ...ru, ...notificationHealthTexts.ru, ...executiveReportTexts.ru },
	es: { ...es, ...notificationHealthTexts.es, ...executiveReportTexts.es },
	ar: { ...ar, ...notificationHealthTexts.ar, ...executiveReportTexts.ar },
	pl: { ...pl, ...notificationHealthTexts.pl, ...executiveReportTexts.pl },
	uk: { ...uk, ...notificationHealthTexts.uk, ...executiveReportTexts.uk },
	ro: { ...ro, ...notificationHealthTexts.ro, ...executiveReportTexts.ro },
	nl: { ...nl, ...notificationHealthTexts.nl, ...executiveReportTexts.nl },
	cs: { ...cs, ...notificationHealthTexts.cs, ...executiveReportTexts.cs },
	ml: { ...ml, ...notificationHealthTexts.ml, ...executiveReportTexts.ml },
	sk: { ...sk, ...notificationHealthTexts.sk, ...executiveReportTexts.sk },
	ka: { ...ka, ...notificationHealthTexts.ka, ...executiveReportTexts.ka },
	si: { ...si, ...notificationHealthTexts.si, ...executiveReportTexts.si },
};
const i18nData = { locale: language, messages, fallbackLocale: 'en',  silentTranslationWarn: true }
const i18n = new VueI18n(i18nData);

Vue.prototype.$roomTypeLabel = function (roomType) {
  if (roomType == null || roomType === '') return ''
  const key = String(roomType).trim().toLowerCase()
  return this.$te(key) || this.$te(key, 'en') ? this.$t(key) : String(roomType)
}

Vue.filter('timePassed', timePassed)
Vue.filter('numberToHour', numberToHour)
Vue.filter('ddmmyy', ddmmyy)
Vue.filter('ddmm', ddmm)
Vue.filter('dd', dd)
Vue.filter('spacedTxt', spacedTxt)
Vue.filter('formatSeconds', formatSeconds)
Vue.filter('capitalize', capitalize)
Vue.filter('statusColor', statusColor)
Vue.filter('hhmm', hhmm)

Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      if (!(el == event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
    if (el.clickOutsideEvent) {
      document.body.removeEventListener('click', el.clickOutsideEvent)
    }
  },
});

// Register Google Analytics event tracking directive
Vue.directive('ga-event', gaEvent);

new Vue({
  i18n,
  router,
  store,
  vuetify: new Vuetify({
    icons: {
      iconfont: 'mdiSvg', // Can be 'mdi', 'mdiSvg', 'md', or 'fa'
    },
  }),
  render: h => h(App),
}).$mount('#app');
